const adminPageConstants = {
  adminPage: {
    tabs: {
      userList: 'users',
      roleList: 'roles',
      siteList: 'sites',
      instrumentationList: 'instrumentation',
      mteTypeList: 'mteTypes',
      notificationBanner: 'notification',
      notificationTemplates: 'notificationTemplates',
    },
  },
  adminCookies: {
    admin_selected_tab: 'admin_selected_tab',
  },
};
export default adminPageConstants;
